module.exports = __webpack_public_path__ + "img/yourcenar.eca59dd8.jpg";